// Pure UI policy: generation only replaces an existing QPT after confirmation.
export const canReplaceQpt = (currentQpt, confirmed = false) =>
  !String(currentQpt || "").trim() || confirmed;


// The API normally returns the V2 structured flow. Accept a legacy textual
// response too so an already-running older local backend cannot produce a
// misleading success toast followed by an empty editor.
export const normaliseGeneratedQpt = (payload, components = []) => {
  let flow = payload?.qpt_flow;
  if (typeof flow === "string") {
    try { flow = JSON.parse(flow); } catch { flow = null; }
  }
  if (Array.isArray(flow?.stages) && flow.stages.length) {
    return { stages: flow.stages.map((stage, index) => ({
      id: stage.id || `generated-stage-${index + 1}`,
      order: Number(stage.order) || index + 1,
      action: String(stage.action || "Prepare"),
      input_refs: Array.isArray(stage.input_refs) ? stage.input_refs : [],
      instruction: String(stage.instruction || ""),
      time: String(stage.time || ""),
      temperature: String(stage.temperature || ""),
      // Preserve saved/generated vessel data through editor state and persistence.
      vessel_equipment: String(stage.vessel_equipment || ""),
      equipment_refs: Array.isArray(stage.equipment_refs) ? stage.equipment_refs : [],
      notes: String(stage.notes || ""),
    })) };
  }
  const legacyQpt = String(payload?.qpt || "").trim();
  if (!legacyQpt) return null;
  const firstInstruction = legacyQpt.split(/\n|\./).map(line => line.replace(/^\s*\d+[.)]\s*/, "").trim()).find(Boolean) || "Prepare";
  return { stages: [{
    id: "generated-stage-1", order: 1, action: firstInstruction,
    input_refs: components.map((_, index) => `component:${index}`),
    instruction: legacyQpt, time: "", temperature: "", vessel_equipment: "", equipment_refs: [], notes: "",
  }] };
};
